import type { TGuarantorColumns } from '@/features/_columns/guarantor-table-column'
import { guarantorColumns } from '@/features/_columns/guarantor-table-column'
import { DataTable } from '@/features/_components/data-table'
import type { TExposedPersonDTO } from '@doutorsim/shared/exposed/persons'
import { useMemo } from 'react'

interface GuarantorsTableProps {
  search?: string
  applicationId: string
  companySlug: string
  facilitySlug: string
  guarantors: TExposedPersonDTO[]
}

export const GuarantorsTable = ({
  applicationId,
  companySlug,
  facilitySlug,
  guarantors,
}: GuarantorsTableProps) => {
  const data: TGuarantorColumns[] = useMemo(
    () =>
      guarantors.map((guarantor) => ({
        id: guarantor.id,
        applicationId,
        companySlug,
        facilitySlug,
        name: guarantor.name,
        email: guarantor.email,
        phone: guarantor.phone,
      })),
    [applicationId, companySlug, facilitySlug, guarantors],
  )

  return <DataTable columns={guarantorColumns} data={data} />
}
